import { Input, Text } from "@clipboard-health/ui-components";
import { FormControl, type InputBaseComponentProps, Stack } from "@mui/material";
import { MaskedPhoneInput } from "@src/appV2/lib/FormFields/PhoneField/MaskedPhoneInput";
import { type FunctionComponent } from "react";
import { Controller } from "react-hook-form";

import { useRecruiterBookingFlowContext } from "../../hooks/useRecruiterBookingFlowContext";

export function RecruiterScreeningCallContactDetailsForm() {
  const {
    contactDetailsForm: { control, formState },
  } = useRecruiterBookingFlowContext();

  return (
    <form
      onSubmit={(event) => {
        event.preventDefault();
      }}
    >
      <Stack spacing={4}>
        <Controller
          control={control}
          name="phone"
          render={({ field }) => (
            <Stack spacing={2}>
              <Text semibold>Phone</Text>
              <FormControl>
                <Input
                  {...field}
                  fullWidth
                  inputComponent={
                    MaskedPhoneInput as unknown as FunctionComponent<InputBaseComponentProps>
                  }
                  placeholder="Phone"
                  type="tel"
                  size="large"
                  error={Boolean(formState.errors.phone)}
                />
              </FormControl>
            </Stack>
          )}
        />
      </Stack>
    </form>
  );
}
